// extracted by mini-css-extract-plugin
module.exports = {"root":"RichText_root__s_5Cq","lg":"RichText_lg__IX7Z9","invert":"RichText_invert__IMaeM","article":"RichText_article__qfjFc"};